/** «Розклад в інверторі зараз» (D2): the read program in rows and words. */
import type { InverterProgram, SiteResponse } from 'shared';

import type { MessageKey } from '../i18n/messages.js';

/** DEYE work mode in words; an unknown one as DeyeCloud names it. */
export function workModeText(t: (k: MessageKey) => string, mode: unknown): string {
  if (typeof mode !== 'string') return t('site.orig.unknown');
  const key = `site.orig.mode.${mode}` as MessageKey;
  return t(key) === key ? mode : t(key);
}

/** Rows of the 6 windows: each until the next one's start, the last until midnight. */
export function programRows(p: InverterProgram) {
  return p.windows.map((w, i) => ({
    n: i + 1,
    from: w.time,
    to: p.windows[i + 1]?.time ?? '24:00',
    gridCharge: w.grid_charge,
    powerKw: w.power_w / 1000,
    socPct: w.soc_pct,
  }));
}

/**
 * D9: the warning of a 0 A charge or discharge current in the inverter's
 * settings (the battery does not charge, discharge); null — none, or not read.
 */
export function zeroCurrentKey(
  c: SiteResponse['inverter_settings']['battery_currents'],
): 'site.zero_current.both' | 'site.zero_current.charge' | 'site.zero_current.discharge' | null {
  const charge = c?.charge_a === 0;
  const discharge = c?.discharge_a === 0;
  if (charge && discharge) return 'site.zero_current.both';
  if (charge) return 'site.zero_current.charge';
  return discharge ? 'site.zero_current.discharge' : null;
}

/**
 * The schedule's kW within the installer's limits: any window at most
 * `powerKw`; a grid charge at most `gridKw` (0 — none: the switch off, or the
 * currents are Phage's; not known — `powerKw`).
 */
export function limitsPlan(l: SiteResponse['inverter_settings']['limits']): {
  powerKw: number;
  gridKw: number;
} {
  return { powerKw: l.power_kw, gridKw: l.grid_charge_kw ?? l.power_kw };
}
